import { ArrowUpRight, CircleCheck, CircleAlert, FileText } from "lucide-react";
import { BrandLogo } from "@/components/ui/brand-logo";
import { useLocale } from "@/i18n/context";

/** A clearly labelled illustration using the published synthetic sample's figures. */
export function ReportSampleCard({ compact = false }: { compact?: boolean }) {
  const { t } = useLocale();
  return (
    <div className={`report-sample ${compact ? "report-sample-compact" : ""}`}>
      <div className="report-sample-header">
        <BrandLogo />
        <span className="sample-pill"><FileText className="h-3 w-3" />{t.brand.sampleLabel}</span>
      </div>
      <div className="report-sample-property">
        <p>{t.brand.sampleType}</p>
        <h2>Trubarjeva ulica 10</h2>
        <div className="report-property-meta"><span>78,5 m²</span><span>1985</span><span>Ljubljana</span></div>
      </div>
      <div className="report-sample-value">
        <p className="sample-caption">{t.brand.estimate}</p>
        <div className="sample-value">227.964 <span>€</span></div>
        <div className="sample-range"><span /></div>
        <div className="sample-range-labels"><span>205.199 €</span><span>250.729 €</span></div>
        <p className="sample-range-note">{t.brand.uncertainty}</p>
      </div>
      <div className="report-sample-evidence">
        <p className="sample-caption">{t.brand.sources}</p>
        {[t.brand.sourceSales, t.brand.sourceRegistry, t.brand.sourceListings].map((label) => (
          <div key={label}><span><CircleCheck className="h-3.5 w-3.5" />{label}</span><ArrowUpRight className="h-3.5 w-3.5" /></div>
        ))}
      </div>
      <div className="report-sample-check">
        <CircleAlert className="h-4 w-4 shrink-0" />
        <div><p>{t.brand.checks}</p><strong>{t.brand.checkTitle}</strong><span>{t.brand.checkNote}</span></div>
      </div>
      <p className="sample-disclaimer">{t.brand.sampleDisclaimer}</p>
    </div>
  );
}
